/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/firstdemo.glb 
*/

import React, { useEffect, useRef } from "react";
import { shaderMaterial, useGLTF, useTexture } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const FrameMaterial = shaderMaterial(
  {
    uTexture: new THREE.Texture(),
    utextureSize: new THREE.Vector2(1, 1),
  },
  `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  `
uniform sampler2D uTexture;
uniform vec2 utextureSize;

varying vec2 vUv;

void main() {
    gl_FragColor = texture2D(uTexture, vUv);
}

  `
);
extend({ FrameMaterial });

export function MountainCalendar({
  image = "/image2.jpg",
  frameSize = { width: 2, height: 1 },
  Tablecolor = "white",
  PotColor = "white",
  PlantBcolor = "white",
  color = "white",
  ...props
}) {
  const { nodes, materials } = useGLTF("/3d/FinalTC.glb");
  const texture = useTexture(image);
  const container = useRef(null);
  const materialRef = useRef();

  const [aspectX, aspectY] = [frameSize.width, frameSize.height];
  const baseSize = 2;
  const scaleX = (aspectX / Math.max(aspectX, aspectY)) * baseSize;
  const scaleY = (aspectY / Math.max(aspectX, aspectY)) * baseSize;
  const yPosition = -scaleY + 1.0;

  useEffect(() => {
    if (materialRef.current) {
      materialRef.current.uniforms.uTexture.value = texture;
      materialRef.current.uniforms.utextureSize.value.set(1, 1);
    }
  }, [texture]);

  useFrame(() => {
    if (container.current) {
      container.current.rotation.y += 0.0015;
    }
  });

  return (
    <group
      ref={container}
      receiveShadow
      castShadow
      {...props}
      dispose={null}
      position={[0, -0.6, 0]}
      rotation={[0, -Math.PI / 2, 0]}
    >
      <mesh
        receiveShadow
        castShadow
        geometry={nodes.Table003.geometry}
        material={nodes.Table003.material}
        position={[-0.003, 0.06, 0.002]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[0.9, 0.9, 0.9]}
      >
        <meshStandardMaterial color={Tablecolor} side={THREE.DoubleSide} />
      </mesh>
      <group
        receiveShadow
        castShadow
        scale={[1.0, scaleY, scaleX]}
        position={[0, yPosition, 0]}
      >
        <mesh
          castShadow
          geometry={nodes.Plane001.geometry}
          position={[0.045, 1.202, 0.038]}
          rotation={[-Math.PI / 2, -0.157, Math.PI / 2]}
          scale={[0.19, 0.178, 0.19]}
        >
          <frameMaterial
            ref={materialRef}
            key={FrameMaterial.key}
            side={THREE.DoubleSide}
          />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.main001.geometry}
          material={nodes.main001.material}
          position={[-0.005, 1.151, 0.036]}
          rotation={[Math.PI / 2, 0, -3.111]}
          scale={[1, 0.8333, 1.111]}
        >
          <meshStandardMaterial color="black" />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.bind001.geometry}
          material={nodes.bind001.material}
          position={[0.009, 1.383, 0.036]}
          rotation={[-1.745, -1.398, 2.965]}
          scale={[1, 0.803, 1]}
        >
          <meshStandardMaterial color="black" />
        </mesh>
      </group>
      <group receiveShadow castShadow position={[0.125, -0.03, 0.15]}>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder006_Flowerpot5_0003.geometry}
          material={nodes.Cylinder006_Flowerpot5_0003.material}
          position={[0.078, 1.077, 0.453]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <meshBasicMaterial color={PlantBcolor} />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Plane081_Haworthia_leaf_0003.geometry}
          material={materials["Haworthia_leaf.003"]}
          position={[0.113, 1.162, 0.458]}
        />
      </group>
      <group position={[0.125, -0.03, -0.15]}>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Object_4003.geometry}
          material={materials["Material.027"]}
          position={[0, 1.008, -0.386]}
          scale={0.168}
        >
          <meshBasicMaterial color={PotColor} />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Object_5002.geometry}
          material={materials["Material.028"]}
          position={[0, 1.008, -0.386]}
          scale={0.168}
        >
          <meshBasicMaterial color={PotColor} />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cube_Metal_0002.geometry}
          material={materials["Metal.003"]}
          position={[-0.044, 1.287, -0.403]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[0.009, 0.013, 0.002]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder_BlackMetal_0002.geometry}
          material={materials["BlackMetal.003"]}
          position={[-0.055, 1.163, -0.395]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={0.172}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder_Metal_0002.geometry}
          material={materials["Metal.003"]}
          position={[-0.055, 1.163, -0.395]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={0.172}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder001_Material_0002.geometry}
          material={materials["Material.029"]}
          position={[-0.008, 1.144, -0.35]}
          rotation={[0.279, -0.05, -0.025]}
          scale={0.001}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder002_Material002_0002.geometry}
          material={materials["Material.030"]}
          position={[-0.008, 1.148, -0.349]}
          rotation={[0.279, -0.05, -0.025]}
          scale={0.001}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Cylinder_Material001_0005.geometry}
          material={materials["Material.031"]}
          position={[-0.008, 1.144, -0.35]}
          rotation={[0.279, -0.05, -0.025]}
          scale={0.001}
        />
        <group position={[-0.03, -0.02, 0]}>
          <mesh
            geometry={nodes.Cylinder001_Material004_0002.geometry}
            material={materials["Material.032"]}
            position={[0.046, 1.283, -0.469]}
            rotation={[2.77, -0.2, 0.062]}
            scale={0.0005}
          />
          <mesh
            geometry={nodes.Cylinder002_Material005_0002.geometry}
            material={materials["Material.033"]}
            position={[0.047, 1.295, -0.474]}
            rotation={[2.77, -0.2, 0.062]}
            scale={0.00015}
          />
          <mesh
            geometry={nodes.Cylinder003_Material002_0002.geometry}
            material={materials["Material.034"]}
            position={[0.04, 1.185, -0.43]}
            rotation={[2.77, -0.2, 0.062]}
            scale={0.0005}
          />
          <mesh
            geometry={nodes.Cylinder_Material001_0006.geometry}
            material={materials["Material.035"]}
            position={[0.04, 1.185, -0.43]}
            rotation={[2.77, -0.2, 0.062]}
            scale={0.0005}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/3d/FinalTC.glb");
